var magicStyles = [".text[data-v-51300f1e]{text-align:center;margin:0 auto var(--magic-space,16px)}.action[data-v-51300f1e]{margin:0 auto;width:100%;max-width:var(--magic-element-default-width,288px)}"];

export default magicStyles;
